import { MapStyle } from '@/icons'

import { CloseButton } from '../../../../elements/CloseButton'
import { NavigoIconButton } from '../../../../elements/NavigoIconButton'
import { useDepotsNavigator } from '../../hooks/useDepotsNavigator'
import { useNavigoView } from '../../hooks/useNavigoView'
import { Actions } from './components/Actions'
import { EntityRelations } from './components/EntityRelations'
import { Stats } from './components/Stats'

import { useTexts } from './useTexts'

export function Overview() {
  const texts = useTexts()
  const { currentDepots } = useDepotsNavigator()
  const {
    navigate: { goToMapStyle },
  } = useNavigoView()

  return (
    <>
      <Stats />
      <Actions />
      <NavigoIconButton
        testid="navigo-depots-overview-style-on-map-trigger"
        text={currentDepots.length > 1 ? texts.styleAll : texts.style}
        Icon={<MapStyle size={20} color="$nightRider" />}
        onClick={goToMapStyle}
      />
      <EntityRelations />
      <CloseButton />
    </>
  )
}
